import { apiClient } from './client';

/**
 * Admin bulk import — User CSV upload.
 *
 * Backend: `apps/chat-server/src/modules/users/admin-bulk-import.routes.ts`
 * Endpoint: POST /api/v1/admin/users/bulk-import (multipart/form-data, field=file)
 *
 * Status code:
 * - 200: 모든 행 성공
 * - 207: 일부 행 실패 (errors[] 확인)
 * - 400/403/413: 입력/권한/크기 오류
 */

// BulkImportErrorCode — `@workchat/shared-types` 패키지에서 import (cross-package SSOT, T3).
// 종전 본 파일이 14 string literal hardcode + (직전 cycle F7/H5) UI 측 KNOWN derive 였으나,
// bulk-import-frontend-types-ssot cycle T1 으로 shared-types/admin-bulk-import.ts 가 SSOT 이 됨.
//
// T8/M2 봉합: KNOWN/CODE_DOC dead re-export 제거 — frontend 다른 파일은 `@workchat/shared-types`
// 에서 직접 import (canonical path). 본 모듈은 BulkImportErrorCode type re-export 만 유지하여
// `import type { ... } from '../../api/admin-bulk-import'` 사용처 (UserSection) 호환 보존.
import type { BulkImportErrorCode } from '@workchat/shared-types';
export type { BulkImportErrorCode };

export interface BulkImportRowError {
  row: number;
  email: string | null;
  /** 알려진 코드는 BulkImportErrorCode, 미정의 시 server 가 보낸 string 그대로 (KNOWN_BULK_IMPORT_CODES 로 분기). */
  code: BulkImportErrorCode | string;
  message: string;
}

export interface BulkImportResult {
  totalRows: number;
  successCount: number;
  failureCount: number;
  errors: BulkImportRowError[];
  /** A2 — audit 영속화 여부. false 시 admin 이 별도 추적 필요. */
  auditPersisted: boolean;
  /** A3 — 클라이언트 abort 로 도중에 중단됐는지. */
  aborted: boolean;
}

export async function bulkImportUsers(file: File): Promise<BulkImportResult> {
  const form = new FormData();
  form.append('file', file);
  const { data } = await apiClient.post<BulkImportResult>(
    '/admin/users/bulk-import',
    form,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      // 207 도 정상 응답으로 받기
      validateStatus: (s) => s === 200 || s === 207,
    },
  );
  // 방어 가드(additive) — errors 가 배열이 아닌 비정형 응답에도 소비처 map 크래시 차단.
  return { ...data, errors: Array.isArray(data?.errors) ? data.errors : [] };
}
